import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';

import { receiveTickets } from '@ttstr/actions';
import { Container, LoadingSpinner, useIntl, Masonry, ProductDetailHeader, ContentrArea } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { Link } from 'react-router-dom';

const TicketListing: React.FC = () => {
  const { t } = useTranslation();
  const { loading, tickets } = useShallowEqualSelector(mapStateToProps);
  const { receiveTickets } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveTickets();
  }, [language]);

  return (
    <article className="pb-5 ticket-listing mb-5">
      {/* <div className="text-center">
        <img src={require('./assets/images/irieunion_header.png')} alt="" className="img-fluid my-5" />
      </div> */}

      <Container className="list-page">
        <Helmet>
          <title>{t(`TICKETLISTING.TITLE`)}</title>
          <body className="ticket-listing-page" />
        </Helmet>

        <h1 className="text-md-center mb-5 pagetitle">TICKETS</h1>

        <Container className="listing-filter-buttons-container">
          <Row className="mb-5 d-flex justify-items-center justify-content-center listing-buttons-container">
            <Col className="mt-3">
              <Link to="/tickets" className="btn btn-lg btn-block btn-outline-dark btn-tickets h-100 active">
                {'TICKETS'}
              </Link>
            </Col>
            <Col className="mt-3">
              <Link to="/products" className="btn btn-lg btn-block btn-outline-dark btn-tickets h-100">
                {'MERCHANDISE'}
              </Link>
            </Col>
            <Col className="mt-3">
              <Link to="/reissues" className="btn btn-lg btn-block btn-outline-dark btn-tickets h-100">
                {'VINYL RE-ISSUES'}
              </Link>
            </Col>
          </Row>
        </Container>

        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.TICKETS`)} />
        ) : tickets.length === 0 ? ( // if no tickets
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show tickets
          <Masonry id="ticket-listing" products={tickets} type="list" showCity showLocation showSubtitle />
        )}
        <ContentrArea id="after-ticket-listing" />
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { tickets, loading } = state.Tickets;
  return {
    tickets,
    loading,
  };
};

const mapDispatchToProps = {
  receiveTickets,
};

export default React.memo(TicketListing);
